import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, Observable } from 'rxjs';
import { AppStorageService } from './app-storage.service';
import { SecureStorageService } from './secure-storage.service';

const LANGUAGE_STORAGE_KEY = 'ppuLanguagePreference';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  constructor(
    private translateService: TranslateService,
    private appStorageService: AppStorageService,
    private secureStorageService: SecureStorageService
  ) {}

  async loadLanguage(): Promise<void> {
    const language = await this.secureStorageService.getSecureStorageData(
      LANGUAGE_STORAGE_KEY
    );
    this.applyLanguage(language || 'en');
  }

  async setLanguage(language: string): Promise<void> {
    await this.secureStorageService.setSecureStorageData(
      LANGUAGE_STORAGE_KEY,
      language
    );
    // Wait for the language file, so callers that translate right after (the
    // success toast) get the new language instead of the previous one.
    await firstValueFrom(this.applyLanguage(language));
  }

  // loadLanguage() doesn't wait on the result: app startup must not block on
  // (or fail with) the language file.
  private applyLanguage(language: string): Observable<unknown> {
    this.appStorageService.languagePreference.set(language);
    return this.translateService.use(language);
  }
}
